import React from 'react';
type SectionProps = {
  id?: string;
  tone?: 'dark' | 'darker' | 'light';
  children: React.ReactNode;
  className?: string;
};
const tones: Record<NonNullable<SectionProps['tone']>, string> = {
  dark: 'bg-navy-900 text-white',
  darker: 'bg-navy-950 text-white',
  light: 'bg-[#F4F6F9] text-navy-950'
};
export function Section({
  id,
  tone = 'darker',
  children,
  className = ''
}: SectionProps) {
  return <section id={id} className={`w-full px-4 py-12 sm:px-6 sm:py-16 ${tones[tone]} ${className}`} data-id="element-72" data-mp="cgpx9wxh9t0s">
      <div className="mx-auto w-full max-w-3xl" data-id="element-73" data-mp="he89pxapeqdj">{children}</div>
    </section>;
}
export function Eyebrow({
  children,
  tone = 'dark'
}: {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
}) {
  return <p className={`text-center font-display text-[13px] font-bold uppercase tracking-[0.16em] sm:text-[15px] ${tone === 'light' ? 'text-gold-600' : 'text-gold-500'}`} data-id="element-74" data-mp="7n3qumhwqldf">
      {children}
    </p>;
}
export function Heading({
  children,
  tone = 'dark'
}: {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
}) {
  return <h2 className={`text-balance mt-2 text-center font-display text-[30px] font-extrabold uppercase leading-[1.05] sm:text-[42px] ${tone === 'light' ? 'text-navy-950' : 'text-white'}`} data-id="element-75" data-mp="2uma6qd9iwo2a">
      {children}
    </h2>;
}